import React from "react";

export default function NewsTab({
    name,
    onClick,
    selectedTab,
}: {
    name: string;
    onClick: () => void;
    selectedTab: string;
}) {
    return (
        <div
            className={`w-fit text-nowrap border-[1px] border-purple px-6 py-2 rounded-full transition-colors duration-300 delay-50
            hover:cursor-pointer capitalize ${
                selectedTab === name
                    ? "bg-purple text-white font-semibold"
                    : "text-purple hover:bg-purple hover:text-white"
            }`}
            onClick={onClick}
        >
            {name}
        </div>
    );
}
